<template>
  <div>
    <div v-if="classroomStreamData">

      <div class="vx-row mb-4">
        <div class="vx-col w-full">
        <classroom-stream-banner :classroom-id="classroomData.id" :color="classroomData.color" :name="classroomData.name" :banner="classroomStreamData.banner"
                                 @refresh="refresh"/>
        </div>
      </div>

      <div class="vx-row mb-4">
        <div class="vx-col w-1/4">
          <classroom-stream-sidebar :color="classroomData.color" :information="classroomStreamData.information"
                                    @updateTab="updateTab"/>
        </div>
        <div class="vx-col w-3/4">
          <classroom-stream-main  :classroom-id="classroomData.id" :color="classroomData.color"/>
        </div>
      </div>
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>
</template>

<script>
import ClassroomStreamBanner from '../components/stream/ClassroomStreamBanner'
import ClassroomStreamSidebar from '../components/stream/ClassroomStreamSidebar'
import ClassroomStreamMain from '../components/stream/ClassroomStreamMain'

export default {
  name: 'ClassroomStreamTab',
  components: {
    ClassroomStreamBanner,
    ClassroomStreamSidebar,
    ClassroomStreamMain
  },
  props: {
    classroomId: {
      type: String,
      required: true
    },
    classroomData: {
      type: Object,
      required: true
    },
    classroomStreamData: {
      type: Object,
      required: true
    }
  },
  methods: {
    refresh () {
      this.$emit('refresh')
    },
    updateTab (id) {
      this.$emit('updateTab', id)
    }
  }
}
</script>

<style scoped>

</style>
